import React, { useState, useEffect, useRef } from "react";
//import { useNavigate } from "react-router-dom";
import LoginForm from "../../components/auth/LoginForm";
import useLogin from "../../hooks/useLogin"; // pakai hook buatanmu

const Login = ({ setIsLoggedIn }) => {
  //const navigate = useNavigate();
  const emailRef = useRef(null);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  //  Gunakan custom hook untuk handle login
  const { handleLogin, isSubmitting, error } = useLogin(setIsLoggedIn);

  useEffect(() => {
    emailRef.current?.focus();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin({ email, password }); //  Panggil fungsi login dari hook
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-gradient-to-br from-green-100 to-green-300">
      <div className="w-full max-w-md p-8 bg-white shadow-2xl rounded-3xl animate-fade-in">
        <h2 className="mb-8 text-3xl font-bold text-center text-green-700">
          🌿 Sistem Koperasi
        </h2>

        <LoginForm
          email={email}
          password={password}
          showPassword={showPassword}
          isSubmitting={isSubmitting}
          error={error}
          emailRef={emailRef}
          setEmail={setEmail}
          setPassword={setPassword}
          setShowPassword={setShowPassword}
          handleSubmit={handleSubmit}
        />
      </div>
    </div>
  );
};

export default Login;
